import { useMutation } from '@tanstack/react-query';
import Config from 'src/common/Config';

const API_URL = Config.getApiUrl();

export function useRecordConversationDiscard() {
  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation({
    mutationFn: async (conversationId: string) => {
      const response = await fetch(`${API_URL}/conversations/${conversationId}/record-discard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.status < 200 || response.status > 299) throw response;
    },
  });

  const recordConversationDiscard = async (conversationId: string) => {
    return mutateAsync(conversationId);
  };

  return {
    recordConversationDiscard,
    error,
    isLoading,
    reset,
  };
}
